export default "__VITE_ASSET__CdV$EUIW__"